import { Box } from '@mui/material';
import { FC } from 'react';

import { AbgTypography } from '@abg/kit-base';
import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useTranslationContext } from '../../../../shared/context';
import { AncillariesI18nKeys } from '../../../../shared/types';
import { RateTermsNotes } from '../RateTermsNotes';

import { RateTermsCountryCodes } from './rate-terms-summary.constants';
import { RateTermsSummaryProps } from './rate-terms-summary.types';

export const RateTermsSummary: FC<RateTermsSummaryProps> = ({
  rateTerms,
  currency = 'USD',
  isPayNowChecked,
}) => {
  const { t, i18nKeys, showRateSummaryTitle } =
    useTranslationContext<AncillariesI18nKeys>();
  const { country } = usePageContext();

  const isCountryUSorCA =
    country === RateTermsCountryCodes.US ||
    country === RateTermsCountryCodes.CA;
  const isCountryAUorNZ =
    country === RateTermsCountryCodes.AU ||
    country === RateTermsCountryCodes.NZ;

  return (
    <Box>
      <AbgTypography
        component="div"
        fontSize={'inherit'}
        data-testid="rate-terms-container"
      >
        {showRateSummaryTitle && (
          <AbgTypography
            component="div"
            variant="bodySmallRegular"
            data-testid="rate-terms-title"
          >
            {t(i18nKeys.rateTermsTitle)}
          </AbgTypography>
        )}

        {isCountryAUorNZ && (
          <AbgTypography
            component="div"
            data-testid="rate-terms-info-label"
            variant="bodySmallMedium"
          >
            {t(i18nKeys.rateTermsInfoLabel)}
          </AbgTypography>
        )}

        {isCountryUSorCA && (
          <AbgTypography
            component="div"
            data-testid="rate-terms-info-label"
            variant="bodySmallMedium"
          >
            {t(i18nKeys.rateTermsInfoLabel)}
          </AbgTypography>
        )}

        <AbgTypography
          data-testid="rate-terms-description"
          component="div"
          variant="bodySmallRegular"
        >
          {t(i18nKeys.rateTermsInfoDescription)}
        </AbgTypography>
      </AbgTypography>

      <RateTermsNotes
        rateTerms={rateTerms}
        currency={currency}
        isPayNowChecked={isPayNowChecked}
      />
    </Box>
  );
};
